import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Input from "../components/shared/input";
import Button from "../components/shared/button";
import { useNavigate } from "react-router-dom";
import { login } from "../APIs/userAuthApi";
import { useTranslation } from "react-i18next";
import { showErrorToast, showSuccessToast } from "../utils/helpers";
import { message } from "antd";
import { toast } from "react-toastify";

const Userlogin = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Define form validation schema with Yup
  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email format").required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  // Initialize formik with initial values, validation schema, and submit handler
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
    
      login(values.email, values.password)
        .then((res) => {
          message.success(res.message);
    
          // Check if role exists in the response
          const userRole = res.user?.role; 
    
          if (userRole === "Admin") {
            navigate("/admin-dashboard"); // Admin dashboard
            toast.success("Admin login successfully");
          } else {
            navigate("/dashboard"); // Default CRM dashboard
            toast.success("User login successfully");
          }
        })
        .catch((err) => {
          toast.error(err);
        });
    },
 
  });

  return (
    <div className="flex flex-col lg:flex-row min-h-screen items-center max-md:gap-[60px] max-md:justify-start justify-center bg-lightwhite p-[20px]">
      {/* Left side */}
      <div className="max-md:min-h-[10vh] max-md:border-none min-h-[80vh] border-solid border-r-2 border-r-gray-200 flex flex-col items-center justify-center w-full md:w-1/2">
        <img
          src="../../assets/images/dashboard/logo_large.png"
          alt="logo"
          className="w-100 h-100 max-md:w-[60px] max-md:h-[60px]"
        />
        <p className="text-blue font-bold text-[34px] max-md:text-[18px]">
          {t("login.leftSide.title")}
        </p>
      </div>

      {/* Right side */}
      <div className="flex flex-col items-center justify-center w-full md:w-1/2">
        <div className="w-full max-w-sm">
          {/* <p className="text-lightgray small leading-[15px]">Admin panel</p> */}
          <h4 className="small font-bold text-black">Log In</h4>
          <p className="text-lightgray small leading-[15px]">{t("login.rightSide.desc")}</p>

          {/* Formik form handler */}
          <form className="mt-[35px]" onSubmit={formik.handleSubmit}>
            <Input
              type="email"
              name="email"
              placeholder={t("login.rightSide.emailPlaceholder")}
              leftImg="../../assets/icons/Message.svg"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email && (
              <div className="text-red-500 text-xs" style={{ color: "red" }}>
                {formik.errors.email}
              </div>
            )}

            <div className="mt-[28px] mb-[8px] flex justify-end">
              <a
                href="/reset-password"
                className="text-[10px] text-[#818181] hover:underline font-medium"
              >
                {t("login.rightSide.forgotPassword")}
              </a>
            </div>

            <Input
              type="password"
              name="password"
              placeholder={t("login.rightSide.passwordPlaceholder")}
              icon="mingcute:eye-2-fill"
              leftImg="../../assets/icons/Unlock.svg"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
            />
            {formik.touched.password && formik.errors.password && (
              <div className="text-red-500 text-xs" style={{ color: "red" }}>
                {formik.errors.password}
              </div>
            )}

            <Button
              text={t("login.rightSide.button")}
              type="submit"
              className="button btn-blue w-full mt-[38px]"
              height={50}
            />
          </form>
          <p className="small flex justify-center gap-[4px] m-auto mt-[8px]">
            {t("login.rightSide.noAccount")}
            <a href="/signup" className="font-semibold">
              {t("login.rightSide.signup")}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Userlogin;
